import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      light: '#fff',
      main: '#e0e4e4',
      dark: '#f0f4f4',
      contrastText: '#000',
    },
    secondary: {
      light: '#856ed1',
      main: '#7864bc',
      dark: '#5b4b8e',
      contrastText: '#fff',
    },
  },
});
